import React from 'react';

const initialContext = {
  isMobile: null,
  isMobileUA: null,
  isTablet: null,
};

const AppContext = React.createContext(
  initialContext,
);

export default AppContext;
